import { createFileRoute } from "@tanstack/react-router";
import Lokacije from "../../pages/admin/Lokacije";

export const Route = createFileRoute("/admin/lokacije")({
  component: Lokacije,
});
